import { render, staticRenderFns } from "./StartupCreateModal.vue?vue&type=template&id=bee2fbc0&"
import script from "./StartupCreateModal.vue?vue&type=script&lang=js&"
export * from "./StartupCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./StartupCreateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports